<template>
  <div class="patient-general--wrap">
    <div class="patient-general">
      <v-container>
        <v-row>
          <v-col class="d-flex align-center justify-start">
            <v-btn
              v-if="!currentPatient.isActive && roleAllowedToManageAccount"
              text
              color="bhRedDark"
              class="rounded-pill mr-2"
              elevation="0"
              @click="promptDeleteParticipant"
            >
              Delete participant
            </v-btn>
            <v-btn
              v-if="roleAllowedToManageAccount"
              text
              color="bhRedDark"
              class="rounded-pill mr-2"
              elevation="0"
              @click="promptActivation"
            >
              {{ currentPatient.isActive ? 'Deactivate' : 'Activate' }}
              participant
            </v-btn>
            <v-btn
              v-if="currentPatient.isActive && roleAllowedToManageAccount"
              text
              color="accent"
              class="rounded-pill mr-2"
              elevation="0"
              @click="promptResetPassword"
            >
              Reset password
            </v-btn>
            <v-btn
              v-if="currentPatient.isActive"
              color="accent"
              class="rounded-pill mr-2"
              elevation="0"
              @click="promptSendWelcomeEmail"
            >
              Send welcome e-mail
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="currentPatient.practiceName">
          <v-col>
            <p>
              <span class="section-title provider">Company: </span
              >{{ currentPatient.practiceName }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="input-group">
              <label for="joinDate" class="bh-text-input__label"
                >Registered</label
              >
              <p v-if="currentPatient.creationDate" class="registered-text">
                {{ currentPatient.creationDate | moment('MMMM Do, YYYY') }}
              </p>
            </div>
          </v-col>
          <!-- <v-col>
            <bh-select
              class="mb-3"
              :disabled="!currentPatient.isActive"
              label="Status"
              v-model="currentPatient.status"
              :items="participantStatuses"
              item-text="text"
              item-value="value"
              @input="inputUpdate('status', $event)"
              clearable
            />
          </v-col> -->
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <p class="section-title">Personal data</p>
            <bh-text-input
              label="Nick name"
              v-model="currentPatient.nick"
              v-if="currentPatient.nick"
              readonly
            />
            <bh-text-input
              label="First name"
              v-model="currentPatient.firstName"
              inputEditingBackgroundClass="bhBlue4"
              :showConfirmEdit="currentPatient.isActive"
              @input="inputUpdate('firstName', $event)"
              :readonly="!currentPatient.isActive"
            />
            <bh-text-input
              label="Last name"
              v-model="currentPatient.lastName"
              inputEditingBackgroundClass="bhBlue4"
              :showConfirmEdit="currentPatient.isActive"
              @input="inputUpdate('lastName', $event)"
              :readonly="!currentPatient.isActive"
            />
            <bh-text-input
              label="Mobile number"
              v-model="currentPatient.phone"
              :type="'tel'"
              inputEditingBackgroundClass="bhBlue4"
              :showConfirmEdit="currentPatient.isActive"
              @input="inputUpdate('phone', $event)"
              :readonly="!currentPatient.isActive"
            />
            <bh-text-input
              label="Email address"
              v-model="currentPatient.email"
              inputEditingBackgroundClass="bhBlue4"
              @input="inputUpdate('email', $event)"
              :showConfirmEdit="true"
              :validate="true"
              :validationType="'email'"
              :type="'email'"
            />
            <bh-select
              class="mb-3"
              :disabled="!currentPatient.isActive"
              label="Chat language (BETA)"
              v-model="currentPatient.language"
              :items="languagesDictionary"
              item-text="text"
              item-value="value"
              @input="inputUpdate('language', $event)"
            />
            <template
              v-if="
                (isAnyAdminRole || roleAllowedToManageAccount) &&
                  currentPatient.isActive
              "
            >
              <p class="section-title">Feature Settings</p>
              <bh-select
                class="mb-3"
                :disabled="!isAnyAdminRole || !currentPatient.isActive"
                :label="tenantTexts.participantDetails.swapFlag"
                v-model="currentPatient.swapAvailable"
                :items="computedFeatureFlagsSwap"
                item-text="text"
                item-value="value"
                @input="changeFeatureFlag('swapAvailable', $event)"
              />
              <bh-select
                v-if="featuresSettings.VUE_FEATURE_SMART_SURVEY"
                class="mb-3"
                :disabled="!isAnyAdminRole || !currentPatient.isActive"
                :label="tenantTexts.participantDetails.smartSurveyFlag"
                v-model="currentPatient.smartSurveyAvailable"
                :items="computedFeatureFlagsSmartSurvey"
                item-text="text"
                item-value="value"
                @input="changeFeatureFlag('smartSurveyAvailable', $event)"
              />
              <bh-select
                class="mb-3"
                :disabled="
                  !roleAllowedToManageAccount || !currentPatient.isActive
                "
                :label="tenantTexts.participantDetails.journalFlag"
                v-model="currentPatient.journalAvailable"
                :items="computedFeatureFlagsJournal"
                item-text="text"
                item-value="value"
                @input="changeFeatureFlag('journalAvailable', $event)"
              />
              <bh-select
                v-if="featuresSettings.VUE_FEATURE_SCREENER"
                class="mb-3"
                :disabled="!isAnyAdminRole || !currentPatient.isActive"
                :label="tenantTexts.participantDetails.surveyFlag"
                v-model="currentPatient.surveyAvailable"
                :items="computedFeatureFlagsSurvey"
                item-text="text"
                item-value="value"
                @input="changeFeatureFlag('surveyAvailable', $event)"
              />
            </template>
            <template v-if="!hideMetricsTargets">
              <p class="section-title">Target</p>
              <bh-text-input
                label="Water glasses"
                v-model="currentPatient.waterGlasses"
                :showConfirmEdit="currentPatient.isActive"
                inputEditingBackgroundClass="bhBlue4"
                @input="inputUpdate('waterGlasses', $event)"
                :readonly="!currentPatient.isActive"
              />
              <bh-text-input
                label="Steps"
                v-model="currentPatient.steps"
                :showConfirmEdit="currentPatient.isActive"
                inputEditingBackgroundClass="bhBlue4"
                @input="inputUpdate('steps', $event)"
                :readonly="!currentPatient.isActive"
              />
            </template>
          </v-col>
          <v-col cols="12" md="6">
            <p class="section-title">Cared for by</p>
            <bh-select
              :disabled="!this.isAdmin && !this.isPracticeAdmin"
              class="mb-3"
              v-if="patientHasPracticeId"
              label="Advisor"
              v-model="currentPatient.practiceUserId"
              :items="computedDoctors"
              item-text="fullName"
              item-value="id"
              @input="inputUpdate('practiceUserId', $event)"
            />
            <!-- <bh-text-input label="Company" v-model="currentPatient.practice" inputEditingBackgroundClass="bhBlue4" :showConfirmEdit="currentPatient.isActive" @input="inputUpdate('practice', $event)" /> -->
            <!-- <bh-text-input label="Advisor" v-model="currentPatient.doctor" inputEditingBackgroundClass="bhBlue4" :showConfirmEdit="currentPatient.isActive" @input="inputUpdate('doctor', $event)" /> -->
            <bh-select
              v-if="this.isAdmin"
              :disabled="!this.isAdmin"
              class="mb-3"
              label="Consultant"
              v-model="currentPatient.consultantId"
              :items="isAdmin ? bhUsersComputed : bhUsersByStaffComputed"
              item-text="fullName"
              item-value="id"
              @input="inputUpdate('consultantId', $event)"
              clearable
            ></bh-select>
            <date-picker
              v-if="patientHasPracticeId"
              :date="currentPatient.procedureDate"
              label="Target date"
              @input="
                inputUpdate(
                  'procedureDate',
                  $moment($event).format('YYYY-MM-DD[T]HH:mm:ss'),
                )
              "
              :readonly="!currentPatient.isActive"
            />
            <bh-text-area
              label="Welcome Message"
              class="patient-general__welcome-message"
              :resize="false"
              :counter="!currentPatient.welcomeMessageRegistered && 500"
              :showConfirmEdit="
                currentPatient.isActive &&
                  !currentPatient.welcomeMessageRegistered
              "
              :value="currentPatient.welcomeMessage"
              @input="inputUpdate('welcomeMessage', $event)"
              :validate="true"
              :validationType="'maxlength'"
              :readonly="!!currentPatient.welcomeMessageRegistered"
            />
            <p class="section-title">Programs</p>
            <v-select
              v-if="isAllowedToChangePrograms"
              v-model="programs"
              :items="availablePrograms"
              :item-text="'name'"
              return-object
              chips
              multiple
              @input="updatePrograms($event)"
              placeholder="Select program"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ programs.length - 1 }} others)
                </span>
              </template>
            </v-select>
            <div v-else>
              <v-chip-group
                v-if="currentPatient.programs && currentPatient.programs.length"
              >
                <v-chip
                  v-for="program in currentPatient.programs"
                  :key="`user-program-${program.id}`"
                  >{{ program.name }}</v-chip
                >
              </v-chip-group>
              <p v-else>No programs have been assigned.</p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="patient-general-sidebar bhGray6">
      <p class="section-title d-flex justify-space-between bhGray2--text">
        Notes
        <v-icon
          color="accent"
          v-if="!notesEditable && currentPatient.isActive"
          @click="startEditingNotes"
        >
          bhi-pencil
        </v-icon>
      </p>
      <v-textarea
        id="notes"
        name="notes"
        :readonly="!notesEditable || !currentPatient.isActive"
        label=" "
        hide-details
        ref="notes"
        placeholder=" "
        auto-grow
        :class="notesEditable ? 'bhWhite' : 'bhGray6'"
        class="patient-general__input patient-general__input--note pt-0"
        v-model="notes"
      ></v-textarea>
      <v-btn
        @click="saveNotes"
        class="rounded-pill my-3"
        color="accent"
        elevation="0"
        v-if="notesEditable"
      >
        Save
      </v-btn>
      <v-btn
        @click="cancelEditingNotes"
        class="rounded-pill my-3 ml-2"
        color="accent--text"
        elevation="0"
        v-if="notesEditable"
      >
        Cancel
      </v-btn>
      <v-snackbar v-model="notificationSnackbar">
        {{ notificationSnackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="notificationSnackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-dialog
        v-model="confirmationPopupWelcomeMessage"
        persistent
        max-width="290"
        @click:outside="onClickOutsideConfirmationWelcome"
        @keydown="onKeydownConfirmationWelcome"
      >
        <v-card v-if="currentPatient.practiceUserId">
          <v-card-title class="headline">Welcome email</v-card-title>
          <v-card-text v-if="!currentPatient.welcomeMessageRegistered">
            <template
              v-if="
                currentPatient.smartSurveyAvailable ===
                  this.dictionaryFeatureFlagState[
                    this.dictionaryFeatureFlagState.Inactive
                  ]
              "
            >
              Are you sure you want to send it to this participant
            </template>
            <template v-else>
              This mail contains a unique url to the Smart Survey. Are you sure
              you want to send it to this participant?
            </template>
          </v-card-text>
          <v-card-text v-if="currentPatient.welcomeMessageRegistered">
            <template
              v-if="
                currentPatient.smartSurveyAvailable ===
                  this.dictionaryFeatureFlagState[
                    this.dictionaryFeatureFlagState.Inactive
                  ]
              "
            >
              This mail has already been sent ({{
                currentPatient.welcomeMessageRegistered
                  | moment('MMMM Do, YYYY')
              }}). Are you sure you want to send it again?
            </template>
            <template v-else>
              This mail with a unique url to the Smart Survey has already been
              sent ({{
                currentPatient.welcomeMessageRegistered
                  | moment('MMMM Do, YYYY')
              }}). Are you sure you want to send it again?
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="rounded-pill"
              text
              @click="confirmationPopupWelcomeMessage = false"
              >Cancel</v-btn
            >
            <v-btn
              class="rounded-pill elevation-0"
              color="accent"
              @click="
                confirmationPopupWelcomeMessage = false
                prepareSendWelcomeEmail()
              "
              >Send it</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-card v-else>
          <v-card-title class="headline">Welcome email</v-card-title>
          <v-card-text
            >Please assign advisor before sending welcome e-mail.</v-card-text
          >
          <v-card-actions>
            <v-btn
              class="rounded-pill"
              text
              @click="confirmationPopupWelcomeMessage = false"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="confirmationPopupResetPassword"
        persistent
        max-width="290"
        @click:outside="onClickOutsideConfirmationResetPassword"
        @keydown="onKeydownConfirmationResetPassword"
      >
        <v-card>
          <v-card-title class="headline"
            >Reset password for this<br />participant?</v-card-title
          >
          <v-card-text
            >This action will reset password for this participant. This action
            is irreversible! Proceed with caution.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="rounded-pill"
              text
              @click="confirmationPopupResetPassword = false"
              >Cancel</v-btn
            >
            <v-btn
              class="rounded-pill elevation-0"
              color="accent"
              @click="
                confirmationPopupResetPassword = false
                prepareResetParticipantPassword()
              "
              >Reset password</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <remove-user-dialog
        :show-dialog="confirmationPopupDelete"
        :delete-title="
          'This action will resign this participant form WLP. This action is irreversible! Proceed with caution.'
        "
        :delete-button-title="'Remove participant'"
        @confirmDeleteUser="deleteParticipant"
        @close-dialog="confirmationPopupDelete = false"
      />
      <v-dialog
        v-model="confirmationPopupActivation"
        persistent
        max-width="290"
        @click:outside="onClickOutsideConfirmationActivation"
        @keydown="onKeydownConfirmationActivation"
      >
        <v-card>
          <v-card-title class="headline"
            >{{
              currentPatient.isActive ? 'Deactivate' : 'Activate'
            }}
            Participant?</v-card-title
          >
          <v-card-text v-if="currentPatient.isActive"
            >You are about to deactivate this Participant. After this action the
            Participant will not be able to log in. You can activate the
            Participant back again. Do you want to proceed?</v-card-text
          >
          <v-card-text v-else
            >You are about to activate this Participant. Do you want to
            proceed?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="rounded-pill"
              text
              @click="confirmationPopupActivation = false"
              >No</v-btn
            >
            <v-btn
              class="rounded-pill elevation-0"
              color="accent"
              @click="
                confirmationPopupActivation = false
                participantActiveToggle()
              "
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="showProcedureDateChangePopup"
        persistent
        max-width="290"
        @click:outside="onClickOutsideProcedureDateChange"
        @keydown="onKeydownProcedureDateChange"
      >
        <v-card>
          <v-card-title class="headline">Change target date?</v-card-title>
          <v-card-text
            >Target date change impacts the Timed Release calendar - some of the
            events will be adjusted accordingly. This change can cause they will
            be sent later than initially planned or won't be sent at all. Please
            review the Timed Release. Do you confirm the change?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="rounded-pill"
              text
              @click="closeProcedureDateChangePopup"
              >Cancel</v-btn
            >
            <v-btn
              class="rounded-pill elevation-0"
              color="accent"
              @click="confirmProcedureDateChange"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import BhTextInput from '@/components/inputs/BhTextInput.vue'
import BhTextArea from '@/components/inputs/BhTextArea.vue'
import BhSelect from '@/components/inputs/BhSelect.vue'
import DatePicker from '@/components/inputs/DatePicker.vue'
import RemoveUserDialog from '@/components/dialogs/RemoveUserDialog.vue'
import TenantTextsMixin from '@/mixins/tenantTexts'
import FeaturesSettingsMixin from '@/mixins/featuresSettings'
import LanguagesMixin from '@/mixins/languages'

// @ is an alias to /src
export default {
  name: 'PatientGeneral',
  components: {
    BhTextInput,
    BhTextArea,
    BhSelect,
    DatePicker,
    RemoveUserDialog,
  },
  mixins: [TenantTextsMixin, FeaturesSettingsMixin, LanguagesMixin],
  data: () => ({
    menu: false,
    notesEditable: false,
    notificationSnackbar: false,
    notificationSnackbarText: '',
    confirmationPopupWelcomeMessage: false,
    confirmationPopupResetPassword: false,
    confirmationPopupDelete: false,
    confirmationPopupActivation: false,
    practiceDoctors: [],
    showProcedureDateChangePopup: false,
    procedureDateToSet: null,
    programs: [],
    editableNotes: '',
  }),
  computed: {
    ...mapGetters('userStates', ['getRolename']),
    ...mapState('patientsStates', [
      'currentPatient',
      'patientProgramOptions',
      'timedReleaseMessagesDefinitions',
    ]),
    ...mapState('programsStates', {
      availablePrograms: 'programs',
      availableProgramsLoading: 'loading',
    }),
    ...mapGetters('patientsStates', ['patientProgram', 'patientHasPracticeId']),
    ...mapState('bhUsersStates', ['bhUsers', 'loading']),
    ...mapState('dictionariesStates', [
      'dictionaryBhUsersRoleIds',
      'dictionaryPracticeUserRole',
      'dictionaryFeatureFlagState',
    ]),
    isAdmin() {
      return (
        this.dictionaryBhUsersRoleIds[this.getRolename] ===
        this.dictionaryBhUsersRoleIds.Admin
      )
    },
    isAdvisor() {
      return (
        this.dictionaryPracticeUserRole[this.getRolename] ===
        this.dictionaryPracticeUserRole.Advisor
      )
    },
    isPracticeAdmin() {
      return (
        this.dictionaryPracticeUserRole[this.getRolename] ===
        this.dictionaryPracticeUserRole.Administrator
      )
    },
    isAnyAdminRole() {
      return this.isAdmin || this.isPracticeAdmin
    },
    isAllowedToChangePrograms() {
      return this.isPracticeAdmin || this.isAdvisor
    },
    roleAllowedToManageAccount() {
      return (
        this.dictionaryBhUsersRoleIds[this.getRolename] ===
          this.dictionaryBhUsersRoleIds.Admin ||
        this.dictionaryPracticeUserRole[this.getRolename] ===
          this.dictionaryPracticeUserRole.Administrator ||
        this.dictionaryPracticeUserRole[this.getRolename] ===
          this.dictionaryPracticeUserRole.Advisor
      )
    },
    consultantsQueryParams() {
      return {
        roleId: this.dictionaryBhUsersRoleIds.Consultant,
        isActive: true,
        sortBy: 'fullName',
        isAvailable: true,
      }
    },
    doctorQueryParams() {
      return {
        roleIds: [
          this.dictionaryPracticeUserRole.Advisor,
          this.dictionaryBhUsersRoleIds.Consultant,
        ],
        isActive: true,
        sortBy: 'fullName',
        isAvailable: true,
      }
    },
    bhUsersComputed() {
      let bhUsers = this.bhUsers.map(bhUser => ({
        ...bhUser,
        fullName: `${bhUser.firstName} ${bhUser.lastName}`,
      }))
      if (
        this.currentPatient.consultantId &&
        !this.bhUsers.find(x => x.id === this.currentPatient.consultantId)
      ) {
        console.log('consultant not found on list')
        bhUsers.push({
          id: this.currentPatient.consultantId,
          firstName: this.currentPatient.consultantFullName,
          lastName: '',
          fullName: this.currentPatient.consultantFullName,
        })
      }
      return bhUsers
    },
    bhUsersByStaffComputed() {
      const { consultantId, consultantFullName } = this.currentPatient || {}
      // if logged user is not bhUser and current Patient has assigned consultant
      if (!this.isAdmin && consultantId && consultantFullName) {
        return [
          {
            id: consultantId,
            fullName: consultantFullName,
          },
        ]
      }

      return []
    },
    computedDoctors() {
      return this.practiceDoctors.map(doctor => ({
        ...doctor,
        fullName: `${doctor.firstName} ${doctor.lastName}`,
      }))
    },
    hideMetricsTargets() {
      return (
        this.currentPatient.journalAvailable ===
        this.dictionaryFeatureFlagState[
          this.dictionaryFeatureFlagState.Inactive
        ]
      )
    },
    participantStatuses() {
      return [
        { text: 'Tech Challenged', value: 'TECH_CHALLENGED' },
        { text: 'Home Challenged', value: 'HOME_CHALLENGED' },
        { text: 'Communication Challenged', value: 'COMMUNICATION_CHALLENGED' },
        { text: 'Resistance to Change', value: 'RESISTANCE_TO_CHANGE' },
        { text: 'Actively Changing', value: 'ACTIVELY_CHANGING' },
      ]
    },
    computedFeatureFlagsJournal() {
      return [
        {
          text: 'Journal & Metrics',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Active
          ],
        },
        {
          text: 'Journal only',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Partial
          ],
        },
        {
          text: 'Journal off',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Inactive
          ],
        },
      ]
    },
    computedFeatureFlagsSmartSurvey() {
      return [
        {
          text: 'Full survey',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Active
          ],
        },
        {
          text: 'Initial questions only',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Partial
          ],
        },
        {
          text: 'Survey off',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Inactive
          ],
        },
      ]
    },
    computedFeatureFlagsSwap() {
      return [
        {
          text: 'Active',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Active
          ],
        },
        {
          text: 'Inactive',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Inactive
          ],
        },
      ]
    },
    computedFeatureFlagsSurvey() {
      return [
        {
          text: 'Active',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Active
          ],
        },
        {
          text: 'Inactive',
          value: this.dictionaryFeatureFlagState[
            this.dictionaryFeatureFlagState.Inactive
          ],
        },
      ]
    },
    consultant: {
      get: function() {
        const { consultantId, consultantFullName } = this.currentPatient || {}
        // if logged user is not bhUser and current Patient has assigned consultant
        return !this.isAdmin && consultantId && consultantFullName
          ? {
              id: consultantId,
              firstName: consultantFullName,
              lastName: '',
            }
          : this.bhUsers.find(x => x.id === this.currentPatient.consultantId) ||
              {}
      },
      set: function(newVal) {
        return newVal
      },
    },
    bhUsersQuery() {
      const params = new URLSearchParams()
      for (const [key, value] of Object.entries(this.consultantsQueryParams)) {
        if (value) params.append(key, value)
      }
      return params
    },
    doctorsQuery() {
      const params = new URLSearchParams()
      for (const [key, value] of Object.entries(this.doctorQueryParams)) {
        if (Array.isArray(value)) {
          value.forEach(item => {
            params.append(key, item)
          })
        } else if (value) {
          params.append(key, value)
        }
      }
      return params
    },
    notes: {
      get() {
        return this.notesEditable
          ? this.editableNotes
          : this.currentPatient.notes
      },
      set(val) {
        this.editableNotes = val
      },
    },
    isDoctor() {
      return this.dictionaryPracticeUserRole.Advisor
    },
  },
  watch: {
    async currentPatient(patient) {
      if (this.isAdmin) {
        this.getBhUsers(this.bhUsersQuery)
      }

      if (patient?.practiceId) {
        const doctors = await this.getPracticeUsers({
          id: patient.practiceId,
          params: this.doctorsQuery,
          returnData: true,
        })

        this.practiceDoctors = doctors || []

        if (this.isAllowedToChangePrograms) {
          this.getPrograms({
            companyId: patient.practiceId,
            active: true,
          })
        }
      }

      this.programs = patient?.programs || []
    },
    $route(to, from) {
      // get new current patient data when patient id changed
      if (to.params?.id !== undefined && from.params?.id !== to.params?.id) {
        this.getPatient(to.params.id)
      }
    },
  },
  methods: {
    ...mapActions('patientsStates', [
      'changePatientField',
      'changePatientFeatureFlag',
      'getTimedReleaseMessagesDefinitions',
      'getPatient',
      'sendWelcomeEmail',
      'resetParticipantPassword',
    ]),
    ...mapActions('programsStates', ['getPrograms', 'assignProgramsToProfile']),
    ...mapActions('bhUsersStates', ['getBhUsers']),
    ...mapActions('practicesStates', ['getPracticeUsers']),
    ...mapActions('userStates', ['toggleActivationAccount', 'deleteUser']),
    changeFeatureFlag(key, value) {
      this.changePatientFeatureFlag({ key, value, id: this.currentPatient.id })
    },
    inputUpdate(key, value) {
      this.changePatientField({ key, value, id: this.currentPatient.id })
    },
    async updatePrograms(newPrograms) {
      if (this.currentPatient?.profileId) {
        const programs = [...newPrograms].map(el => ({ programId: el.id }))
        this.assignProgramsToProfile({
          profileId: this.currentPatient?.profileId,
          programs,
        })
      }
    },
    confirmProcedureDateChange() {
      this.inputUpdate('procedureDate', this.procedureDateToSet)
      this.closeProcedureDateChangePopup()
    },
    closeProcedureDateChangePopup() {
      this.procedureDateToSet = null
      this.showProcedureDateChangePopup = false
    },
    startEditingNotes() {
      this.notesEditable = true
      this.editableNotes = this.currentPatient.notes || ''
      this.$nextTick(() => {
        this.$refs.notes.focus()
      })
    },
    cancelEditingNotes() {
      this.notesEditable = false
      this.editableNotes = ''
    },
    promptSendWelcomeEmail() {
      this.confirmationPopupWelcomeMessage = true
    },
    prepareSendWelcomeEmail() {
      this.sendWelcomeEmail({ participantId: this.currentPatient.id }).then(
        () => {
          this.getPatient(this.currentPatient.id)
        },
      )
    },
    promptDeleteParticipant() {
      this.confirmationPopupDelete = true
    },
    promptActivation() {
      this.confirmationPopupActivation = true
    },
    deleteParticipant() {
      if (!this.currentPatient.isActive) {
        this.deleteUser({
          url: `/participants/${this.currentPatient.id}`,
        })
          .then(() => {
            this.$router.push({ name: 'Patients', path: '/participants/' })
          })
          .finally(() => {
            this.confirmationPopupDelete = false
          })
      } else {
        this.confirmationPopupDelete = false
      }
    },
    participantActiveToggle() {
      this.toggleActivationAccount({
        url: `/participants/${this.currentPatient.id}/active`,
        isActive: !this.currentPatient.isActive,
        version: this.currentPatient.version,
      }).then(() => {
        this.getPatient(this.currentPatient.id)
      })
    },
    promptResetPassword() {
      this.confirmationPopupResetPassword = true
    },
    prepareResetParticipantPassword() {
      this.resetParticipantPassword({
        participantId: this.currentPatient.id,
      }).then(() => {
        this.getPatient(this.currentPatient.id)
      })
    },
    saveNotes() {
      this.inputUpdate('notes', this.editableNotes)
      this.notesEditable = false
      this.editableNotes = ''
    },
    closeConfirmationWelcome() {
      this.confirmationPopupWelcomeMessage = false
    },
    closeConfirmationResetPassword() {
      this.confirmationPopupResetPassword = false
    },
    closeConfirmationActivation() {
      this.confirmationPopupActivation = false
    },
    onClickOutsideConfirmationWelcome() {
      this.closeConfirmationWelcome()
    },
    onKeydownConfirmationWelcome(key) {
      if (key.code === 'Escape' && key.isTrusted)
        this.closeConfirmationWelcome()
    },
    onClickOutsideConfirmationResetPassword() {
      this.closeConfirmationResetPassword()
    },
    onKeydownConfirmationResetPassword(key) {
      if (key.code === 'Escape' && key.isTrusted)
        this.closeConfirmationResetPassword()
    },
    onClickOutsideConfirmationActivation() {
      this.closeConfirmationActivation()
    },
    onKeydownConfirmationActivation(key) {
      if (key.code === 'Escape' && key.isTrusted)
        this.closeConfirmationActivation()
    },
    onClickOutsideProcedureDateChange() {
      this.closeProcedureDateChangePopup()
    },
    onKeydownProcedureDateChange(key) {
      if (key.code === 'Escape' && key.isTrusted)
        this.closeProcedureDateChangePopup()
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';
.patient-general {
  padding: 8px 32px 32px;
  flex: 1;
  height: 100%;

  &--wrap {
    display: flex;
  }

  &__input--note textarea {
    padding: 8px !important;
  }

  .container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &-program {
    position: relative;

    &__cover {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: transparent;
    }
  }

  &-sidebar {
    width: 272px;
    padding: 24px;
    .v-textarea {
      .v-input__slot {
        &::before,
        &::after {
          display: none;
        }
      }
    }
    textarea {
      color: #52575c !important;
      line-height: 22px;
      padding: 4px;
      font-size: 14px;
    }
    textarea[readonly] {
      cursor: default;
    }
  }
  .v-input--switch {
    .v-label {
      font-size: 0.857rem;
      font-weight: 700;
      color: $bh-gray--2;
    }
    .v-input__slot {
      background-color: transparent !important;
    }
  }
  label.bh-text-input__label {
    font-weight: 700;
    line-height: 1.425rem;
    color: $bh-gray--2;
    margin-bottom: 3px;
  }
  .section-title.provider {
    border-bottom: 0;
  }
  &__welcome-message {
    label {
      color: $bh-gray--2;
    }
    textarea {
      min-height: 150px;
    }
  }
  .registered-text {
    margin-top: 2px;
    margin-bottom: 0;
    line-height: 40px;
  }
}
</style>
